import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { IceapiService, UserUtilityService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { PipeSizeModel } from '../../../models';
import { Router } from '@angular/router';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';

@Component({
    selector: 'app-min-max-pipe-size',
    templateUrl: './min-max-pipe-size.component.html',
    styleUrls: ['./min-max-pipe-size.component.scss'],
    standalone: false
})
export class MinMaxPipeSizeComponent implements OnInit {
    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        if (value) {
            this.getMinPipespecList(value);
            if (this.form.get('minPipeSize').value) this.getmaxpipeSizeList(value, this.form.get('minPipeSize').value);
        }
        this.form.get('minPipeSize').setValidators(Validators.required);
        this.form.get('maxPipeSize').setValidators(Validators.required);
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set isCustom(value: boolean) {
        this._isCustom = value;
        this.getPipeSizes(null, null);
    }
    get isCustom(): boolean {
        return this._isCustom;
    }

    @Input()
    set calcType(value: number) {
        this.getMinPipespecList(null);
        if (this.form.get('minPipeSize').value) {
            this.getmaxpipeSizeList(null, this.minPipeSizeId);
        }
        this.form.get('minPipeSize').setValidators(Validators.required);
        this.form.get('maxPipeSize').setValidators(Validators.required);
    }

    @Input() enable: boolean;
    @Input() form: UntypedFormGroup;
    @Output() selected: EventEmitter<PipeSizeModel> = new EventEmitter();

    tooltip_position = 'above';
    loading: boolean = false;
    minPipeSizeId: string;
    minoptionList: PipeSizeModel[];
    maxoptionList: PipeSizeModel[];
    stateOptions: any = [
        { label: 'mm', value: 0 },
        { label: 'in', value: 1 },
    ];

    private _clampId: string;
    private _pressureClassId: string;
    private _isCustom: boolean;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        public idmsSharedService: IdmsSharedService,
        public jointCalsCervice: JointCalcService
    ) {}

    async ngOnInit(): Promise<void> {
        // this.primeNGConfig.ripple = true;
        this.form.get('minPipeSize').valueChanges.subscribe(async (val) => {
            if (val) {
                this.minPipeSizeId = val;
                await this.getmaxpipeSizeList(this.pressureClassId, this.minPipeSizeId);
            }
        });
    }

    async getPipeSizes(pressureClassId: string, minPipesize?: number) {
        try {
            let isMetric = this.form.get('pipeSizeType').value == 0 ? true : false;
            this.loading = true;

            return await this.iceapi
                .getPipeSizes(null, pressureClassId, minPipesize, null, isMetric)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .toPromise();
        } catch (e) {
            this.user_utility.errorModelPopup(e);
        }
    }

    async getMinPipespecList(pressureClassId) {
        let pipeSizes = await this.getPipeSizes(pressureClassId, null);
        if (pipeSizes.success) {
            this.minoptionList = pipeSizes.response;
            if (this.form.get('minPipeSize').value) {
                this.dataService.selectedPipeSize = pipeSizes.response.find((item) => this.form.get('minPipeSize').value == item.pipeSizeId)?.pipeName;
            }
            if (this.minoptionList.length === 1) this.form.get('minPipeSize').setValue(this.minoptionList[0].pipeSizeId);
            if (this.form.get('minPipeSize').value) {
                await this.getmaxpipeSizeList(this.pressureClassId, this.form.get('minPipeSize').value);
            }
            this.cd.detectChanges();
        }
    }

    async getmaxpipeSizeList(pressureClassId, minPipeSizeId) {
        const nominalPipeSize = this.minoptionList?.find((p) => p.pipeSizeId === minPipeSizeId).nominalPipeSize;
        let pipeSizes = await this.getPipeSizes(pressureClassId, nominalPipeSize);
        if (pipeSizes.success) {
            this.maxoptionList = pipeSizes.response;

            if (this.maxoptionList.length === 1) this.form.get('maxPipeSize').setValue(this.maxoptionList[0].pipeSizeId, { emitEvent: true });

            this.cd.detectChanges();
        }
    }
}
